/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TagIcon24Solid = forwardRef('TagIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.404 4a4 4 0 0 0-3.105 1.478L.793 9.793a3.5 3.5 0 0 0 0 4.414L4.3 18.522A4 4 0 0 0 7.404 20H18a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H7.404ZM6 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })));
});
